<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ep"> </p>
<p class="epv"><span class="epub-i">Redemption of Sky</span></p>
<p class="epv"> </p>
<p class="epv">Soaring through the clouds</p>
<p class="epv">Arms spread, wind whisking on the back.</p>
<p class="epv">Unaffected by the laws of gravity,</p>
<p class="epv">One symbol of soul and freedom.</p>
<p class="epv">Disrupting the peace with a</p>
<p class="epv">Crack like thunder,</p>
<p class="epv">Lead whistled through the air.</p>
<p class="epv">Piercing pain,</p>
<p class="epv">Arms fold in,</p>
<p class="epv">The graceful glide metamorphoses</p>
<p class="epv">Into a chaotic dive.</p>
<p class="epv">The life meets the ground</p>
<p class="epv">And movement is no more.</p>
<p class="epv">But once again, Free.</p>
<p class="epv"> </p>
<p class="epvc">—Jeremy Glick</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?ef131222